
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host([site='GHS']) h1{
    font-size:inherit;
    line-height:inherit;
  }
:host([site='GHS']) [slot='hero-banner-buttons'] {
    display:flex;
}
:host([site='GHS']) [slot='hero-banner-buttons'] {
    flex-wrap:wrap;
}
:host([site='GHS']) [slot='hero-banner-buttons'] {
    gap:1rem;
}
:host([site='GHS']) [slot='hero-banner-title-button'] {
    right:0px;
}
@media (min-width: 1280px) {
    :host([site='GHS']) [slot='hero-banner-title-button'] {
        position:absolute;
    }
}
@media (min-width: 1280px) {
    :host([site='GHS']) [slot='hero-banner-title-button'] {
        bottom:0.5rem;
    }
}
@media (min-width: 1280px) {
    :host([site='GHS']) [slot='hero-banner-title-button'] {
        top:-1rem;
    }
}
:host([site='GHS']) [slot='hero-banner-author'] p:first-child {
    font-weight:var(--fw-semibold);
}
:host([site='GHS']) [slot='hero-banner-author'] p:nth-child(2) {
    padding-top:0.75rem;
}
:host([site='GHS']) [slot='hero-banner-phone-number'] a {
    text-decoration-line:none;
}
:host([site='GHS']) [slot='hero-banner-phone-number'] a:hover {
    text-decoration-line:underline;
}
:host([site='GHS']) [slot='hero-banner-form'] a {
    color:var(--primary-blue-light-2);
}
:host([site='GHS']) [slot='hero-banner-form'] .sapi-did-you-mean {
    position:relative;
}
:host([site='GHS']) [slot='hero-banner-form'] .sapi-did-you-mean {
    padding-bottom:1.75rem;
}
:host([site='GHS']) [slot='hero-banner-form'] .sapi-did-you-mean {
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
}
:host([site='GHS']) [slot='hero-banner-form'] .sapi-did-you-mean {
    font-weight:var(--fw-bold);
}
:host([site='GHS']) [slot='hero-banner-form'] .sapi-did-you-mean > :first-child {
    padding-left:2rem;
}
:host([site='GHS']) [slot='hero-banner-form'] .sapi-did-you-mean ::after {
    position:absolute;
}
:host([site='GHS']) [slot='hero-banner-form'] .sapi-did-you-mean ::after {
    bottom:0px;
}
:host([site='GHS']) [slot='hero-banner-form'] .sapi-did-you-mean ::after {
    display:block;
}
:host([site='GHS']) [slot='hero-banner-form'] .sapi-did-you-mean ::after {
    min-width:100%;
}
:host([site='GHS']) [slot='hero-banner-form'] .sapi-did-you-mean ::after{
        border-top:1px solid var(--neutral-gray-4);
        content:'';
      }
:host([site='GHS']) [slot='hero-banner-form'] .no-results {
    padding-top:1.75rem;
}
:host([site='GHS']) [slot='hero-banner-form'] .no-results {
    padding-left:2rem;
}
:host([site='GHS']) [slot='hero-banner-form'] .no-results {
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
}
`;